import { sendRequest } from './api';
import { PHONE_REGEX } from './utils';
const BASE_URL = 'appointments';
export const APPOINTMENT_CODES = {
    All: [
        '7SBP',
        'ANF',
        'B-C',
        'C19',
        'CT',
        'E-C',
        'H-C',
        'HR',
        'INTL',
        'ISPA',
        'IZA',
        'PCY',
        'PCY-T',
        'PS',
        'R011',
        'R1264',
        'R65',
        'RV',
        'ST-T',
        'TB-R',
        'TB-T'
    ],
    IMM: [
        '7SBP',
        'ANF',
        'HR',
        'IZA',
        'PCY',
        'PS',
        'R011',
        'R1264',
        'R65',
        'RV'
    ],
    TB: [
        'ANF',
        'PCY',
        'RV',
        'TB-R',
        'TB-T'
    ],
    YAC: [
        'B-C',
        'CT',
        'E-C',
        'H-C',
        'PCY',
        'PCY-T',
        'ST-T'
    ]
};
export const LANGUAGE_OPTIONS = [
    {"value":"en","label":"English"},
    {"value":"fr","label":"French"}
];
export const CLIENT_LANGUAGE_OPTIONS = [{"value":"ab","label":"Abkhazian"},{"value":"aa","label":"Afar"},{"value":"af","label":"Afrikaans"},{"value":"ak","label":"Akan"},{"value":"sq","label":"Albanian"},{"value":"am","label":"Amharic"},{"value":"ar","label":"Arabic"},{"value":"an","label":"Aragonese"},{"value":"hy","label":"Armenian"},{"value":"as","label":"Assamese"},{"value":"av","label":"Avaric"},{"value":"ay","label":"Aymara"},{"value":"az","label":"Azerbaijani"},{"value":"bm","label":"Bambara"},{"value":"ba","label":"Bashkir"},{"value":"eu","label":"Basque"},{"value":"be","label":"Belarusian"},{"value":"bn","label":"Bengali"},{"value":"bi","label":"Bislama"},{"value":"nb","label":"Bokmål, Norwegian; Norwegian Bokmål"},{"value":"bs","label":"Bosnian"},{"value":"br","label":"Breton"},{"value":"bg","label":"Bulgarian"},{"value":"my","label":"Burmese"},{"value":"ca","label":"Catalan; Valencian"},{"value":"km","label":"Central Khmer"},{"value":"ch","label":"Chamorro"},{"value":"ce","label":"Chechen"},{"value":"ny","label":"Chichewa; Chewa; Nyanja"},{"value":"zh","label":"Chinese"},{"value":"cv","label":"Chuvash"},{"value":"kw","label":"Cornish"},{"value":"co","label":"Corsican"},{"value":"cr","label":"Cree"},{"value":"hr","label":"Croatian"},{"value":"cs","label":"Czech"},{"value":"da","label":"Danish"},{"value":"dv","label":"Divehi; Dhivehi; Maldivian"},{"value":"nl","label":"Dutch; Flemish"},{"value":"dz","label":"Dzongkha"},{"value":"en","label":"English"},{"value":"et","label":"Estonian"},{"value":"ee","label":"Ewe"},{"value":"fo","label":"Faroese"},{"value":"fj","label":"Fijian"},{"value":"fi","label":"Finnish"},{"value":"ff","label":"Fulah"},{"value":"gd","label":"Gaelic; Scottish Gaelic"},{"value":"gl","label":"Galician"},{"value":"lg","label":"Ganda"},{"value":"ka","label":"Georgian"},{"value":"de","label":"German"},{"value":"el","label":"Greek, Modern (1453–)"},{"value":"gn","label":"Guarani"},{"value":"gu","label":"Gujarati"},{"value":"ht","label":"Haitian; Haitian Creole"},{"value":"ha","label":"Hausa"},{"value":"he","label":"Hebrew"},{"value":"hz","label":"Herero"},{"value":"hi","label":"Hindi"},{"value":"ho","label":"Hiri Motu"},{"value":"hu","label":"Hungarian"},{"value":"is","label":"Icelandic"},{"value":"ig","label":"Igbo"},{"value":"id","label":"Indonesian"},{"value":"iu","label":"Inuktitut"},{"value":"ik","label":"Inupiaq"},{"value":"ga","label":"Irish"},{"value":"it","label":"Italian"},{"value":"ja","label":"Japanese"},{"value":"jv","label":"Javanese"},{"value":"kl","label":"Kalaallisut; Greenlandic"},{"value":"kn","label":"Kannada"},{"value":"kr","label":"Kanuri"},{"value":"ks","label":"Kashmiri"},{"value":"kk","label":"Kazakh"},{"value":"ki","label":"Kikuyu; Gikuyu"},{"value":"rw","label":"Kinyarwanda"},{"value":"ky","label":"Kirghiz; Kyrgyz"},{"value":"kv","label":"Komi"},{"value":"kg","label":"Kongo"},{"value":"ko","label":"Korean"},{"value":"kj","label":"Kuanyama; Kwanyama"},{"value":"ku","label":"Kurdish"},{"value":"lo","label":"Lao"},{"value":"lv","label":"Latvian"},{"value":"li","label":"Limburgan; Limburger; Limburgish"},{"value":"ln","label":"Lingala"},{"value":"lt","label":"Lithuanian"},{"value":"lu","label":"Luba-Katanga"},{"value":"lb","label":"Luxembourgish; Letzeburgesch"},{"value":"mk","label":"Macedonian"},{"value":"mg","label":"Malagasy"},{"value":"ms","label":"Malay"},{"value":"ml","label":"Malayalam"},{"value":"mt","label":"Maltese"},{"value":"gv","label":"Manx"},{"value":"mi","label":"Māori"},{"value":"mr","label":"Marathi"},{"value":"mh","label":"Marshallese"},{"value":"mn","label":"Mongolian"},{"value":"na","label":"Nauru"},{"value":"nv","label":"Navajo; Navaho"},{"value":"nd","label":"Ndebele, North; North Ndebele"},{"value":"nr","label":"Ndebele, South; South Ndebele"},{"value":"ng","label":"Ndonga"},{"value":"ne","label":"Nepali"},{"value":"se","label":"Northern Sami"},{"value":"no","label":"Norwegian"},{"value":"nn","label":"Norwegian Nynorsk; Nynorsk, Norwegian"},{"value":"oc","label":"Occitan (post 1500)"},{"value":"oj","label":"Ojibwa"},{"value":"or","label":"Oriya"},{"value":"om","label":"Oromo"},{"value":"os","label":"Ossetian; Ossetic"},{"value":"pa","label":"Panjabi; Punjabi"},{"value":"fa","label":"Persian"},{"value":"pl","label":"Polish"},{"value":"pt","label":"Portuguese"},{"value":"ps","label":"Pushto; Pashto"},{"value":"qu","label":"Quechua"},{"value":"ro","label":"Romanian; Moldavian; Moldovan"},{"value":"rm","label":"Romansh"},{"value":"rn","label":"Rundi"},{"value":"ru","label":"Russian"},{"value":"sm","label":"Samoan"},{"value":"sg","label":"Sango"},{"value":"sc","label":"Sardinian"},{"value":"sr","label":"Serbian"},{"value":"sn","label":"Shona"},{"value":"ii","label":"Sichuan Yi; Nuosu"},{"value":"sd","label":"Sindhi"},{"value":"si","label":"Sinhala; Sinhalese"},{"value":"sk","label":"Slovak"},{"value":"sl","label":"Slovenian"},{"value":"so","label":"Somali"},{"value":"st","label":"Sotho, Southern; Southern Sotho"},{"value":"es","label":"Spanish; Castilian"},{"value":"su","label":"Sundanese"},{"value":"sw","label":"Swahili"},{"value":"ss","label":"Swati"},{"value":"sv","label":"Swedish"},{"value":"tl","label":"Tagalog"},{"value":"ty","label":"Tahitian"},{"value":"tg","label":"Tajik"},{"value":"ta","label":"Tamil"},{"value":"tt","label":"Tatar"},{"value":"te","label":"Telugu"},{"value":"th","label":"Thai"},{"value":"bo","label":"Tibetan"},{"value":"ti","label":"Tigrinya"},{"value":"to","label":"Tonga (Tonga Islands)"},{"value":"ts","label":"Tsonga"},{"value":"tn","label":"Tswana"},{"value":"tr","label":"Turkish"},{"value":"tk","label":"Turkmen"},{"value":"tw","label":"Twi"},{"value":"ug","label":"Uighur; Uyghur"},{"value":"uk","label":"Ukrainian"},{"value":"ur","label":"Urdu"},{"value":"uz","label":"Uzbek"},{"value":"ve","label":"Venda"},{"value":"vi","label":"Vietnamese"},{"value":"wa","label":"Walloon"},{"value":"cy","label":"Welsh"},{"value":"fy","label":"Western Frisian"},{"value":"wal","label":"Wolayttattuwa"},{"value":"wo","label":"Wolof"},{"value":"xh","label":"Xhosa"},{"value":"yi","label":"Yiddish"},{"value":"yo","label":"Yoruba"},{"value":"za","label":"Zhuang; Chuang"},{"value":"zu","label":"Zulu"}];

const PHONE_REMINDER_NONE = 0;
const PHONE_REMINDER_PRIMARY_VOICE = 1;
const PHONE_REMINDER_PRIMARY_SMS = 2;
const PHONE_REMINDER_SECONDARY_VOICE = 3;
const PHONE_REMINDER_SECONDARY_SMS = 4;
const PHONE_REMINDER_CUSTOM_VOICE = 5;
const PHONE_REMINDER_CUSTOM_SMS = 6;
const PHONE_REMINDER_OPTIONS = [
    {
        label: 'No reminder',
        value: PHONE_REMINDER_NONE
    },
    {
        label: 'Voice - Primary Phone Number',
        value: PHONE_REMINDER_PRIMARY_VOICE
    },
    {
        label: 'SMS - Primary Phone Number',
        value: PHONE_REMINDER_PRIMARY_SMS
    },
    {
        label: 'Voice - Secondary Phone Number',
        value: PHONE_REMINDER_SECONDARY_VOICE
    },
    {
        label: 'SMS - Secondary Phone Number',
        value: PHONE_REMINDER_SECONDARY_SMS
    },
    {
        label: 'Voice - Alternate Phone Number',
        value: PHONE_REMINDER_CUSTOM_VOICE
    },
    {
        label: 'SMS - Alternate Phone Number',
        value: PHONE_REMINDER_CUSTOM_SMS
    }
];

export const getClientFields = (filteredFields = []) => {
    let codesOptions = Object.keys(APPOINTMENT_CODES)
        .reduce((a, v) => [...a, ...APPOINTMENT_CODES[v]], [])
        .filter((v, i, a) => a.indexOf(v) === i)
        .map(v => { return { label: v, value: v }; });

    if (filteredFields.length > 0) {
        const codesField = filteredFields.find(item => item.name === 'codes');
        if (codesField && codesField.options) {
            codesOptions = codesOptions.filter(item => codesField.options.find(option => option === item.value));
        }
    }

    let clientFields = [
        {
            name: 'firstName',
            label: "First name",
            placeholder: "Enter first name",
            type: 'text',
            required: true
        },
        {
            name: 'lastName',
            label: "Last name",
            placeholder: "Enter last name",
            type: 'text',
            required: true
        },
        {
            name: 'clientId',
            label: 'Client ID',
            type: 'text',
            pattern: '[0-9]{10}',
            maxLength: 10,
            required: false
        },
        {
            name: 'preferredName',
            label: "Preferred name (if different from what appears on health card)",
            placeholder: "Enter preferred name",
            type: 'text',
            required: false
        },
        {
            name: 'pronoun',
            label: "Preferred pronoun",
            placeholder: "Select preferred pronoun",
            type: 'select',
            required: false,
            options: [
                {
                    label: "He",
                    value: 'he'
                },
                {
                    label: "She",
                    value: 'she'
                },
                {
                    label: "They",
                    value: 'they'
                }
            ]
        },
        {
            name: 'dateOfBirth',
            label: "Date of birth",
            placeholder: "Enter date of birth",
            type: 'date',
            showAge: true,
            maxDate: new Date((new Date()).getFullYear(), 12, 31),
            required: false
        },
        {
            name: 'legalGuardian',
            label: "Legal guardian/substitute decision maker first and last name (if applicable)",
            placeholder: "Enter first and last name",
            type: 'text',
            required: false
        },
        {
            name: 'notGuardian',
            label: "Individual accompanying client is NOT the parent or legal guardian",
            type: 'checkbox',
            required: false
        },
        {
            name: 'authorized',
            label: "Authorized by the program manager",
            type: 'checkbox',
            required: false
        },
        {
            name: 'translationServices',
            label: "Translation Services Required",
            type: 'checkbox',
            required: false
        },
        {
            name: "clientLanguage",
            label: "Client's language if translation services required (if not English or French)",
            placeholder: "Select an option",
            type: 'select',
            required: false,
            showSelectToggle: false,
            options: CLIENT_LANGUAGE_OPTIONS
        },
        {
            name: 'codes',
            label: "Codes",
            placeholder: "Select one or more codes",
            type: 'multiselect',
            required: false,
            showSelectToggle: false,
            options: codesOptions,
            adminOnly: true
        },
        {
            name: 'dose',
            label: "Dose #",
            placeholder: "Select dose",
            type: 'number',
            required: false,
            adminOnly: true
        },
        {
            name: 'attendance',
            label: "Client attendance",
            placeholder: "Select a status",
            type: 'select',
            groupEdit: true,
            required: false,
            adminOnly: true,
            options: [
                {
                    label: "Arrived",
                    value: 'arrived'
                },
                {
                    label: "Left",
                    value: 'left'
                },
                {
                    label: "No Show",
                    value: 'noshow'
                },
            ]
        },
        {
            name: 'initials',
            label: "Initials",
            placeholder: "Enter initials",
            type: 'text',
            groupEdit: true,
            maxLength: 2,
            required: false,
            adminOnly: true
        },
        {
            name: 'room',
            label: "Nurse/Room",
            placeholder: "Enter nurse/room",
            type: 'text',
            groupEdit: true,
            required: false,
            adminOnly: true
        }
    ];

    if (filteredFields.length > 0) {
        clientFields = clientFields
            .filter(current => filteredFields.find(item => item.name === current.name) || current.required)
            .map(current => current.required ? current : { ...current, required: filteredFields.find(item => item.name === current.name).required });
    }

    return clientFields;
};

export const getAppointmentFields = (
    calendar,
    availableDurations = [],
    appointmentState
) => {
    const clientFields = getClientFields(calendar.fields);
    let fields = [
        {
            name: 'duration',
            label: 'Duration',
            placeholder: '',
            type: 'select',
            required: true,
            min: 1,
            max: 10,
            options: availableDurations
        },
        {
            name: 'clientData',
            label: 'Client Information',
            placeholder: '',
            singularName: 'Client Information',
            type: 'repeater',
            required: true,
            min: 1,
            max: appointmentState.multipleClients ? 10 : 1,
            addButtonLabel: 'Add Client to Group',
            fields: clientFields,
            defaultState: (appointmentState.multipleClients && appointmentState.clientData.length > 0)
                ? { ...appointmentState.clientData[0], id: null } : getDefaultClientState(calendar.fields)
        },
        {
            name: 'language',
            label: 'Preferred Language',
            labelFr: 'Langue préférée',
            placeholder: 'Select preferred language',
            placeholderFr: 'Veuillez choisir une langue préférée',
            type: 'select',
            required: true,
            options: LANGUAGE_OPTIONS
        },
        {
            name: 'phone',
            label: 'Primary phone number',
            placeholder: 'Enter primary phone number (10 digits)',
            title: "Enter a valid 10-digit phone number",
            type: 'tel',
            maxLength: 12,
            pattern: PHONE_REGEX,
            required: true
        },
        {
            name: 'phoneDoNotCall',
            label: 'Do Not Call Primary Number',
            type: 'checkbox',
            required: false
        },
        {
            name: 'phoneAlt',
            label: 'Secondary phone number',
            placeholder: 'Enter the secondary phone number (10 digits)',
            title: "Enter a valid 10-digit phone number",
            maxLength: 12,
            pattern: PHONE_REGEX,
            type: 'tel'
        },
        {
            name: 'phoneAltDoNotCall',
            label: 'Do Not Call Secondary Number',
            type: 'checkbox',
            required: false
        },
        {
            name: 'phoneReminderType',
            label: 'Voice/SMS Reminder Type',
            type: 'select',
            placeholder: 'Select a value',
            required: true,
            options: PHONE_REMINDER_OPTIONS
        },
        {
            name: 'email',
            label: 'Email',
            placeholder: 'Enter email address',
            type: 'email',
            required: false
        }
    ];

    if (calendar.allowMultipleClients) {
	fields.splice(
            1,
            0,
            {
		name: 'multipleClients',
		label: 'This option allows you to add multiple people to the appointment. SELECT THE CORRECT APPOINTMENT DURATION!',
		type: 'checkbox',
		required: false
	    }
        );
    }

    if (calendar.emailsEnabled) {
        fields = [...fields, ...[
            {
                name: 'sendConfirmationEmail',
                label: 'Confirmation Email',
                placeholder: 'If active, the client will receive a confirmation email.',
                type: 'checkbox',
                required: false
            },
            {
                name: 'sendReminderEmail',
                label: 'Reminder Email',
                placeholder: 'If active, the client will receive a reminder email.',
                type: 'checkbox',
                required: false
            }
        ]];

        /* Add in custom phone number for the reminder */
        if (
            parseInt(appointmentState.phoneReminderType) === PHONE_REMINDER_CUSTOM_VOICE ||
            parseInt(appointmentState.phoneReminderType) === PHONE_REMINDER_CUSTOM_SMS
        ) {
            const phoneReminderCustom = {
                name: 'phoneReminderCustom',
                label: 'Voice/SMS Reminder Phone Number',
                placeholder: 'Enter primary phone number (10 digits)',
                title: "Enter a valid 10-digit phone number",
                maxLength: 12,
                pattern: PHONE_REGEX,
                type: 'tel',
                required: true
            };
            const phoneReminderIndex = fields.findIndex(x => x.name === 'phoneReminderType') + 1;
            fields.splice(
                phoneReminderIndex,
                0,
                phoneReminderCustom
            );
        }

        /* Hide primary phone number options if do not call is checked */
        if (appointmentState.phoneDoNotCall) {
            fields = fields.map(x => x.name === 'phoneReminderType' ? {
                ...x,
                options: PHONE_REMINDER_OPTIONS.filter(
                    y => y.value !== PHONE_REMINDER_PRIMARY_VOICE &&
                        y.value !== PHONE_REMINDER_PRIMARY_SMS
                )
            } : x);
        }

        /* Hide secondary phone number options if do not call is checked */
        if (appointmentState.phoneAltDoNotCall) {
            fields = fields.map(x => x.name === 'phoneReminderType' ? {
                ...x, options: PHONE_REMINDER_OPTIONS.filter(
                    y => y.value !== PHONE_REMINDER_SECONDARY_VOICE &&
                        y.value !== PHONE_REMINDER_SECONDARY_SMS)
            } : x);
        }

        if (
            appointmentState.sendConfirmationEmail ||
            appointmentState.sendReminderEmail
        ) {
            fields.find(x => x.name === 'email').required = true;
        }
    }

    return fields;
};

export const getGroupEditFields = () => {

    return getClientFields().filter(x => x.groupEdit);
};

export const getDefaultAppointmentState = (lane, timeInSeconds, duration = null, lockToken, calendar) => {
    const endTimeInSeconds = timeInSeconds + duration;
    const properties = {
        calendarDateLaneId: parseInt(lane.id),
        startTime: timeInSeconds,
        duration: duration,
        multipleClients: calendar.allowMultipleClients,
        endTime: endTimeInSeconds,
        email: null,
        language: 'en',
        phone: null,
        phoneDoNotCall: false,
        phoneAlt: null,
        phoneAltDoNotCall: false,
        phoneReminderType: 0,
        phoneReminderCustom: null,
        sendConfirmationEmail: false,
        sendReminderEmail: false,
        clientData: [getDefaultClientState(calendar.fields)],
        agreeValidInfo: false,
        agreePhone: false,
        lockToken: lockToken,
        ...(calendar.groupSession && {spots: 1})
    };

    return properties;
};

export const getDefaultClientState = (clientFields = []) => {
    return {
        ...{
            firstName: null,
            lastName: null,
            phone: null
        },
        ...clientFields
            .map(x => x.name)
            .reduce((o, key) => ({ ...o, [key]: (key === 'codes') ? [] : null }), {})
    };
};

export const getAppointment = (id) => {
    return sendRequest(BASE_URL + '/' + id, 'GET');
};

export const createAppointment = (data) => {
    return sendRequest(BASE_URL, 'POST', data);;
};

export const updateAppointment = (appointment) => {
    return sendRequest(BASE_URL + '/' + appointment.id, 'PUT', appointment);
};

export const deleteAppointment = (appointmentId) => {
    return sendRequest(BASE_URL + '/' + appointmentId, 'DELETE');
};

export const getAppointments = (params) => {
    const url = BASE_URL + (params ? '?' + new URLSearchParams(params).toString() : '');
    return sendRequest(url, 'GET');
};
